import React from 'react';
import SamuraiGame from './SamuraiGame';

/**
 * ModernSamurai is the main entry point for the MSP Standards Trainer.
 * It uses the shared SamuraiGame engine to provide the full suite of drills.
 */
const ModernSamurai = () => {
    return <SamuraiGame initialDrillIndex={0} />;
};

export default ModernSamurai;
